<template>
  <div>
    <br />
    <v-row>
      <v-col cols="12" sm="6" md="6" offset="1">
        <!--          Cost -->
        <v-text-field
            v-model.number="item.cost"
            :error-messages="costErrors"
            :label="$t('order.unitCost')"
        />
      </v-col>

    </v-row>


    <v-row>
      <v-col cols="12" sm="6" md="6" offset="1">

        <!--          Material-->
        <v-combobox
            v-model="item.material"
            :items="materialSelectItems"
            :error-messages="materialErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('order.material')"
            item-text="name"
            item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6" offset="1">

        <!--          Risk-->
        <v-combobox
              v-if="riskSelectItems"
              v-model="item.risk"
              :items="riskSelectItems"
              :error-messages="riskErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('order.risk')"
              item-text="comment"
              item-value="@id"
          />
      </v-col>
    </v-row>
  </div>



</template>

<script>
import {mapFields} from "vuex-map-fields";
import {mapActions} from "vuex";
import has from "lodash/has";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";


export default {
  name: 'PopupStateFaisable',
  mixins: [validationMixin],

  components: {

  },

  props: {
    values: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  mounted() {
    this.materialGetSelectItems();
    this.riskGetSelectItems();
  },

  data() {
    return {
      comment: null,
      price: null,
      cost: null,
      risk:null,
    }
  },

  computed: {
    isLoading() {
      return (
          this.isLoading_material
      );
    },


    ...mapFields('material', {
      materialSelectItems: 'selectItems',
      isLoading_material : 'isLoading'
    }),
    ...mapFields('risk', {
      riskSelectItems: 'selectItems',
      isLoading_risk : 'isLoading'
    }),


    item() {
      return this.initialValues || this.values ;
    },


    materialErrors() {
      const errors = [];

      if (!this.$v.item.material.$dirty) return errors;

      has(this.violations, 'material') && errors.push(this.violations.type);
      !this.$v.item.material.required && errors.push(this.$t('global.field_required'));

      return errors;
    },

    riskErrors() {
      const errors = [];

      if (!this.$v.item.material.$dirty) return errors;

      has(this.violations, 'risk') && errors.push(this.violations.type);

      return errors;
    },

    costErrors() {
      const errors = [];

      if (!this.$v.item.cost.$dirty) return errors;
      has(this.violations, 'cost') && errors.push(this.violations.cost);
      !this.$v.item.cost.required && errors.push(this.$t('global.field_required'));
      return errors;
    },

    violations() {
      return this.errors || {};
    },
  },

  methods: {
    ...mapActions({
      materialGetSelectItems: 'material/fetchSelectItems',
      riskGetSelectItems: 'risk/fetchSelectItems',
    }),

    prodFileAdd() {
      this.newProdFile = !this.newProdFile;
    },
    closeExpansionPanel() {
      this.boolExpansionPanel = ! this.boolExpansionPanel
    },
    close() {
      this.closeExpansionPanel()
      this.prodfileGetSelectItems()
    },

  },

  watch: {
    riskSelectItems() {
      if (this.item.risk == null) {
        for (let i = 0; i < this.riskSelectItems.length; i++) {
          if (this.riskSelectItems[i].init) {
            this.item.risk = this.riskSelectItems[i];
          }
        }
      }

    },
  },

  validations: {
    item: {
      cost: {
        required,
      },
      material: {
        required,
      },
      risk: {
      }
    }
  }
}
</script>

